import React from 'react';
import I18n from '@/modules/i18n';
import { TCIDropdown } from '@/components/ui/Dropdown';
import { SlideGroup } from './utils';

interface SlideGroupRowActionsProps {
  group: SlideGroup;
  onDelete: (group: SlideGroup) => void;
  onEdit: (group: SlideGroup) => void;
}

// react-modal handles Escape on any keydown that reaches it, defaultPrevented or not, so an Escape
// that only meant to close this menu would also close the Group Slides modal around it.
const keepEscapeInMenu = (e: React.KeyboardEvent) => {
  if (e.key === 'Escape' && (e.target as HTMLElement).closest('[role="menu"]')) e.stopPropagation();
};

const SlideGroupRowActions = ({ group, onDelete, onEdit }: SlideGroupRowActionsProps) => (
  <div role="presentation" onKeyDown={keepEscapeInMenu}>
    <TCIDropdown align="start">
      <TCIDropdown.Trigger asChild>
        <button className="dropdown-toggle btn btn--outline-purple" type="button">
          {I18n.t('actions')}
        </button>
      </TCIDropdown.Trigger>
      <TCIDropdown.Content width="unset">
        <TCIDropdown.Item onSelect={() => onEdit(group)}>
          <i aria-hidden="true" className="fa fa-pencil-square-o" />
          {I18n.t('edit')}
        </TCIDropdown.Item>
        <TCIDropdown.Item onSelect={() => onDelete(group)}>
          <i aria-hidden="true" className="fa fa-trash" />
          {I18n.t('delete')}
        </TCIDropdown.Item>
      </TCIDropdown.Content>
    </TCIDropdown>
  </div>
);

export default SlideGroupRowActions;
